import { render, staticRenderFns } from "./EventModalCatalogRubricsForm.vue?vue&type=template&id=6a1dc42a&scoped=true"
import script from "./EventModalCatalogRubricsForm.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogRubricsForm.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogRubricsForm.vue?vue&type=style&index=0&id=6a1dc42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1dc42a",
  null
  
)

export default component.exports